import React from 'react';
import r2wc from '@r2wc/react-to-web-component';
import Button from '@adc/ui-core/components/elementals/button';
import { getWebComponentName } from '../utils';
import { useShadowStyles } from '../hooks/useShadowStyles';
const WrappedComponent = props => {
    const ref = useShadowStyles();
    return (React.createElement("div", { ref: ref },
        React.createElement(Button, { ...props },
            React.createElement("slot", null))));
};
const WebButton = r2wc(WrappedComponent, {
    props: {
        role: 'string',
        disabled: 'boolean',
        color: 'string',
        onClick: 'function',
    },
    shadow: 'open',
});
customElements.define(getWebComponentName('button'), WebButton);
